import React from 'react';
import { AutoSizer, Table, Column } from 'react-virtualized';
import { STATUS_LABEL_DETAIL, TEXT_LABEL_DETAIL, TEXT_LABEL_FEETICKET} from './../consts';
import { HeaderConBusqueda } from '../../../components/shared/HeaderConBusqueda.jsx';
import HeaderConFiltro from '../../../components/shared/HeaderConFiltro.jsx'
import { ModalDetailsPayment} from './Modals.jsx';
import ButtonModal from './ButtonModal.jsx';
import style from './Partners.css';

const Partners = (props) => {
    return (
    <div style={{height: '70%', paddingTop:'35px'}}>
        <AutoSizer>
            {({height, width}) =>
                <Table
                    noRowsRenderer={ () => props.loading 
                        ? <div style={{ textAlign: "center", paddingTop: "20px", fontSize: "20px", color: 'black'}}>Cargando...</div> 
                        : <div style={{ textAlign: "center", paddingTop: "20px", fontSize: "20px", color: 'black'}}>Sin registros</div>}
                    height={height}
                    width={width}
                    headerHeight={30}
                    headerClassName={style.Partners_headerColumn}
                    rowCount={props.loading ? 0 : props.partners.length}
                    rowGetter={({index})=> props.partners[index]}
                    rowHeight={40}
                    rowClassName={({index})=> index<0? style.Partners_headerRow : ((index%2===0)? style.Partners_evenRow : style.Partners_oddRow)}
                >
                    <Column
                        dataKey='#'
                        label={'#'}
                        disableSort={true}
                        cellRenderer={({rowIndex}) => rowIndex+1}
                        width={30}
                    />
                    {/*<Column
                        dataKey={'fechaPago'} label="Fecha Pago"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey]}
                        width={120}
                    />*/}
                    <Column
                        dataKey='usuarioRUN' label="RUT"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        headerRenderer={() =>
                            <HeaderConBusqueda
                                nombre="RUN"
                                busqueda={props.searchRun}
                                realizarBusqueda={props.onChangeFilterRun}
                            />
                        }
                        width={100}
                    />
                    <Column
                        dataKey='nombreCompleto' label="Nombre"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        headerRenderer={() =>
                            <HeaderConBusqueda
                                nombre="NOMBRE"
                                busqueda={props.searchName}
                                realizarBusqueda={props.onChangeFilterName}
                            />
                        }
                        width={160}
                    />
                    {props.recruiterId == 0 && <Column
                        dataKey='recruiterName' label="Captador"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        headerRenderer={() =>
                            <HeaderConBusqueda
                                nombre="CAPTADOR"
                                busqueda={props.searchCaptador}
                                realizarBusqueda={props.onChangeFilterCaptador}
                            />
                        }
                        width={160}
                    />}
                    <Column
                        dataKey='cuenta' label="Cuenta"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        width={100}
                    />
                    <Column
                        dataKey='totalInventarios' label="IG"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        width={20}
                    />
                    <Column
                        dataKey='totalFormat' label="A GIRAR"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => rowData[dataKey] }
                        width={70}
                    />
                    <Column
                        dataKey='payrollStatus' label="NOMINA"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>  (
                            <span style={{fontSize: "12px"}}
                                className={`label ${STATUS_LABEL_DETAIL[rowData[dataKey]]}`}>
                                { TEXT_LABEL_DETAIL[rowData[dataKey]] }
                            </span>
                        )}
                        width={80}
                    />
                    <Column
                        dataKey='boleta_subida' label="BOLETA"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>  {
                            let index_color = rowData[dataKey] ? 2 : 0;
                            let index_label = rowData[dataKey] ? 2 : 0;
                            console.log(rowData)
                            return(<span style={{fontSize: "12px"}}
                                className={`label ${STATUS_LABEL_DETAIL[index_color]}`}>
                                { TEXT_LABEL_FEETICKET[index_label] }
                            </span>);
                        }}
                        width={80}
                    />
                    <Column
                        dataKey='no_aprobados' label="PEND"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>  {
                            let aprobados = rowData['aprobados'];
                            let pendientes = rowData['pendientes'];
                            return(<div style={{ textAlign: "center" }} >
                                {pendientes}
                            </div>);
                        }}
                        headerRenderer={() =>
                            <HeaderConFiltro
                                nombre="PEND"
                                filtro={props.filterPendingStatus}
                                actualizarFiltro={props.onChangeFilterPending}
                            />
                        }
                        width={60}
                    />
                    <Column
                        dataKey='approvedStatus' label="ALTA"
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) =>  (
                            <span style={{fontSize: "12px"}}
                                className={`label ${STATUS_LABEL_DETAIL[rowData[dataKey]]}`}>
                                { TEXT_LABEL_DETAIL[rowData[dataKey]] }
                            </span>
                        )}
                        width={80}
                    />
                    <Column
                        dataKey='opciones'
                        cellRenderer={({ cellData, columnData, dataKey, rowData, rowIndex }) => (
                            <ButtonModal 
                                getPartners={props.getPartners} 
                                btnClassName="btn btn-xs btn-info"
                                glyphiconBtn="glyphicon glyphicon-search"
                                btnText=""
                                isEnabled={true}
                            >
                                <ModalDetailsPayment
                                    partner={rowData}
                                    recruiters={props.recruiters}
                                    recruiterId={rowData.recruiterId}
                                    onSelectUpdateRecruiter={props.onSelectUpdateRecruiter}
                                    getPartners={props.getPartners}
                                    clientId={props.clientId}
                                    ceco={props.ceco}
                                />
                            </ButtonModal>
                        )}
                        width={30}
                    />
                </Table>
            }
        </AutoSizer>
    </div>
    )
};
    
export default Partners;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/Partners.jsx